import { jsx as _jsx } from "react/jsx-runtime";
import LoginContext from './LoginContext';
const LoginContextProvider = ({ children, ...props }) => {
    return _jsx(LoginContext.Provider, { value: props, children: children }, void 0);
};
export default LoginContextProvider;
//# sourceMappingURL=LoginContext.provider.js.map